var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetsApp24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Applications, Size=24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9639 10.7V13.3H20.5639V10.7H17.9639ZM17.7639 9.5C17.2116 9.5 16.7639 9.94772 16.7639 10.5V13.5C16.7639 14.0523 17.2116 14.5 17.7639 14.5H20.7639C21.3162 14.5 21.7639 14.0523 21.7639 13.5V10.5C21.7639 9.94772 21.3162 9.5 20.7639 9.5H17.7639Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42047 3.43865V6.03865H6.02047V3.43865H3.42047ZM3.22047 2.23865C2.66818 2.23865 2.22047 2.68636 2.22047 3.23865V6.23865C2.22047 6.79093 2.66818 7.23865 3.22047 7.23865H6.22047C6.77275 7.23865 7.22047 6.79093 7.22047 6.23865V3.23865C7.22047 2.68636 6.77275 2.23865 6.22047 2.23865H3.22047Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42046 10.7V13.3H6.02046V10.7H3.42046ZM3.22046 9.5C2.66817 9.5 2.22046 9.94772 2.22046 10.5V13.5C2.22046 14.0523 2.66817 14.5 3.22046 14.5H6.22046C6.77274 14.5 7.22046 14.0523 7.22046 13.5V10.5C7.22046 9.94772 6.77274 9.5 6.22046 9.5H3.22046Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42046 17.9617V20.5617H6.02046V17.9617H3.42046ZM3.22046 16.7617C2.66817 16.7617 2.22046 17.2094 2.22046 17.7617V20.7617C2.22046 21.314 2.66817 21.7617 3.22046 21.7617H6.22046C6.77274 21.7617 7.22046 21.314 7.22046 20.7617V17.7617C7.22046 17.2094 6.77274 16.7617 6.22046 16.7617H3.22046Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6921 3.43828V6.03828H13.2921V3.43828H10.6921ZM10.4921 2.23828C9.93984 2.23828 9.49213 2.686 9.49213 3.23828V6.23828C9.49213 6.79057 9.93984 7.23828 10.4921 7.23828H13.4921C14.0444 7.23828 14.4921 6.79057 14.4921 6.23828V3.23828C14.4921 2.686 14.0444 2.23828 13.4921 2.23828H10.4921Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6922 10.7V13.3H13.2922V10.7H10.6922ZM10.4922 9.5C9.9399 9.5 9.49219 9.94772 9.49219 10.5V13.5C9.49219 14.0523 9.9399 14.5 10.4922 14.5H13.4922C14.0445 14.5 14.4922 14.0523 14.4922 13.5V10.5C14.4922 9.94772 14.0445 9.5 13.4922 9.5H10.4922Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6922 17.9617V20.5617H13.2922V17.9617H10.6922ZM10.4922 16.7617C9.9399 16.7617 9.49219 17.2094 9.49219 17.7617V20.7617C9.49219 21.314 9.9399 21.7617 10.4922 21.7617H13.4922C14.0445 21.7617 14.4922 21.314 14.4922 20.7617V17.7617C14.4922 17.2094 14.0445 16.7617 13.4922 16.7617H10.4922Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9639 3.43828V6.03828H20.5639V3.43828H17.9639ZM17.7639 2.23828C17.2116 2.23828 16.7639 2.686 16.7639 3.23828V6.23828C16.7639 6.79057 17.2116 7.23828 17.7639 7.23828H20.7639C21.3162 7.23828 21.7639 6.79057 21.7639 6.23828V3.23828C21.7639 2.686 21.3162 2.23828 20.7639 2.23828H17.7639Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9639 17.9617V20.5617H20.5639V17.9617H17.9639ZM17.7639 16.7617C17.2116 16.7617 16.7639 17.2094 16.7639 17.7617V20.7617C16.7639 21.314 17.2116 21.7617 17.7639 21.7617H20.7639C21.3162 21.7617 21.7639 21.314 21.7639 20.7617V17.7617C21.7639 17.2094 21.3162 16.7617 20.7639 16.7617H17.7639Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsApp24);
export default __webpack_public_path__ + "static/media/Assets_App_24.5e6615fe66ed380b8a40128a3b8557bb.svg";
export { ForwardRef as ReactComponent };